/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import type { TivoPayloadAction } from '../../../core/tivo/tivo-redux-wrapper';
import {
    START_GUIDE_PAGE_SCROLL,
    START_TURBO_SCROLL,
    STOP_GUIDE_PAGE_SCROLL,
    STOP_TURBO_SCROLL,
} from './turboscroll.types';

export const startTurboScrollAction = (
    isUpward: boolean = false,
): TivoPayloadAction<{ isUpward: boolean; isTurboScrollActive: boolean }> => ({
    type: START_TURBO_SCROLL,
    payload: {
        isUpward,
        isTurboScrollActive: true,
    },
});

export const stopTurboScrollAction = (): TivoPayloadAction<{
    isUpward: boolean;
    isTurboScrollActive: boolean;
}> => ({
    type: STOP_TURBO_SCROLL,
    payload: {
        isUpward: false,
        isTurboScrollActive: false,
    },
});

export const startGuidePageScrollAction = (
    isGuidePageUpward: boolean = false,
): TivoPayloadAction<{ isGuidePageUpward: boolean; isGuidePageScrollActive: boolean }> => ({
    type: START_GUIDE_PAGE_SCROLL,
    payload: {
        isGuidePageUpward,
        isGuidePageScrollActive: true,
    },
});

export const stopGuidePageScrollAction = (): TivoPayloadAction<{
    isGuidePageUpward: boolean;
    isGuidePageScrollActive: boolean;
}> => ({
    type: STOP_GUIDE_PAGE_SCROLL,
    payload: {
        isGuidePageUpward: false,
        isGuidePageScrollActive: false,
    },
});
